import { formatDate } from "@sp-crm/core";
import { SortingState } from "@tanstack/react-table";
import { CrmTableColumn } from "components/table/types";
import * as React from "react";

export interface FileTableRow {
    originalFilename: string;
    sortableFilename: string;
    description: string;
    createdAt: Date;
    displayUsername: string;
    sortableUsername: string;
}

export const fileTableInitialSort: SortingState = [
    { id: "sortableFilename", desc: false },
];

export const fileTableColumns = <T extends FileTableRow>(
    renderName: (record: T) => JSX.Element,
): CrmTableColumn<T>[] => [
    {
        key: "sortableFilename",
        header: "Name",
        renderCell: ({ record }) => renderName(record),
    },
    {
        key: "description",
        header: "Description",
    },
    {
        key: "createdAt",
        header: "Uploaded",
        renderCell: ({ record }) => <span>{formatDate(record.createdAt)}</span>,
    },
    {
        key: "sortableUsername",
        header: "Uploaded by",
        renderCell: ({ record }) => <span>{record.displayUsername}</span>,
    },
];
